import React, { useState } from "react";

// All styles
import { makeStyles } from "tss-react/mui";

// Components from MUI library
import AppBar from "@mui/material/AppBar";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";

// Loading related components from MUI library
import CircularProgress from "@mui/material/CircularProgress";

// Icons
import ImportExportIcon from "@mui/icons-material/ImportExport";

// Common components/controls
import { ButtonUI } from "../../Common";

const useStyles = makeStyles()((theme) => ({
  Header: {
    fontSize: "1.1rem",
    minHeight: "60px !important",
    color: "black",
    marginTop: 0,
    borderRadius: 0,
    boxShadow: 0,
    fontWeight: 600,
  },
  HeaderTitle: {
    fontSize: 20,
    lineHeight: 1.5,
    paddingTop: 14,
    paddingLeft: 10,
  },
  InnerTileTitle: {
    fontSize: "1.1rem",
    color: "black",
    fontWeight: 600,
    paddingBottom: "10px",
  },
  PaperStyle: {
    mb: 2,
    padding: "10px",
    width: "100%",
    maxWidth: "100%",
    display: "flex",
    flexDirection: "column",
    wordBreak: "break-all",
  },
  PanelContainer: {
    padding: "10px 30px",
    display: "flex",
    flexDirection: "column",
    "& .MuiAlert-message .MuiList-root": {
      listStyle: "square",
    },
    "& .MuiTableContainer-root": {
      borderRadius: "10px",
    },
  },
}));

function ImportSchemas({ schemas, loading, handleImportSchemas }) {
  const { classes } = useStyles();

  const [checkedSchemas, setCheckedSchemas] = useState([]);

  const handleCheckboxClick = (e) => {
    const clickedSchema = e.target.value;
    setCheckedSchemas((prevState) => {
      if (prevState.includes(clickedSchema)) prevState = prevState.filter((schema) => schema !== clickedSchema);
      else prevState = [...prevState, clickedSchema];
      return [...prevState];
    });
  };

  return (
    <>
      <AppBar
        sx={{
          position: "relative",
          boxShadow: 0,
          backgroundColor: "#e8edf1",
        }}
      >
        <Toolbar className={classes.Header}>
          <Grid container spacing={2} direction="row" alignItems={"center"}>
            <Grid
              size={{
                sm: 12,
                xs: 12
              }}>
              <Box sx={{ display: "inline-flex", verticalAlign: "sub", marginRight: "20px" }}>
                <Typography className={classes.HeaderTitle} gutterBottom component="div">
                  Import Schemas
                </Typography>
              </Box>
              <ButtonUI
                variant="contained"
                startIcon={<ImportExportIcon />}
                color="info"
                style={{ marginRight: "20px" }}
                onClick={() => {
                  handleImportSchemas(checkedSchemas);
                  setCheckedSchemas([]);
                }}
                disabled={checkedSchemas.length === 0}
              >
                Import To Vortex
              </ButtonUI>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Box maxWidth="md" className={classes.PanelContainer} sx={{ mb: 2 }}>
        <Paper
          className={classes.PaperStyle}
          sx={{
            ...(loading || schemas.length === 0
              ? { height: "300px", display: "flex", justifyContent: "center", alignItems: "center" }
              : {}),
          }}
        >
          {loading || schemas.length === 0 ? (
            loading ? (
              <CircularProgress />
            ) : (
              "No schemas to import"
            )
          ) : (
            <>
              <Typography className={classes.InnerTileTitle}>Schemas</Typography>
              {schemas.map(({ SCHEMA_NAME, CREATED }) => (
                <Box key={CREATED}>
                  {SCHEMA_NAME.length > 64 ? (
                    <Tooltip
                      placement="left"
                      title="Schema name longer than 64 characters, please rename to import to vortex"
                    >
                      <FormControlLabel
                        value={SCHEMA_NAME}
                        control={<Checkbox checked={checkedSchemas.includes(SCHEMA_NAME)} />}
                        label={SCHEMA_NAME}
                        onChange={(e) => handleCheckboxClick(e)}
                        disabled={SCHEMA_NAME.length > 64}
                      />
                    </Tooltip>
                  ) : (
                    <FormControlLabel
                      value={SCHEMA_NAME}
                      control={<Checkbox checked={checkedSchemas.includes(SCHEMA_NAME)} />}
                      label={SCHEMA_NAME}
                      onChange={(e) => handleCheckboxClick(e)}
                      disabled={SCHEMA_NAME.length > 64}
                    />
                  )}
                </Box>
              ))}
            </>
          )}
        </Paper>
      </Box>
    </>
  );
}

export default React.memo(ImportSchemas);
